module.exports = __webpack_public_path__ + "img/Landing-eclipse.29198158.png";